// extracted by mini-css-extract-plugin
module.exports = {"Menu":"_3byt1H","Link":"t2GBvd"};